export default "__VITE_ASSET__cRCh9yFM__"